var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 16.3821,
    cy: 16.5714,
    rx: 16.3821,
    ry: 16.5714,
    fill: "#166649"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5068 15.3213C25.5381 15.3213 26.3818 14.4775 26.3818 13.4463V10.6025L19.2256 8.25879V9.75879L25.1318 11.54V13.415C25.1318 13.7588 24.8506 14.04 24.5068 14.04H8.25684C7.91309 14.04 7.63184 13.7588 7.63184 13.415V11.54L13.5068 9.75879V8.25879L6.38184 10.6025V13.4463C6.38184 14.4775 7.22559 15.3213 8.25684 15.3213H8.91309V22.8838C7.50684 22.9463 6.38184 24.1025 6.38184 25.5088V26.5713H26.3818V25.5088C26.3818 24.1338 25.3193 23.0088 23.9756 22.8838V15.3213H24.5068ZM21.5068 15.3213H22.7256V22.8525H21.5068V15.3213ZM18.2881 15.3213H20.2568V22.8525H18.2881V15.3213ZM15.8193 15.3213H17.0381V22.8525H15.8193V15.3213ZM12.6631 15.3213H14.5693V22.8525H12.6631V15.3213ZM10.1943 15.3213H11.4131V22.8525H10.1943V15.3213ZM25.1006 25.3213H7.66309C7.75684 24.6338 8.35059 24.1025 9.06934 24.1025H23.6943C24.4131 24.1025 25.0068 24.6338 25.1006 25.3213Z",
    fill: "#004431"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0695 10.04L16.757 10.2275C17.1633 10.3525 17.132 10.6963 17.132 10.79C17.132 10.8525 17.0383 11.2275 16.6008 11.2275C16.382 11.2275 15.7258 11.1025 15.2883 11.0088L15.1008 11.9775C15.1945 12.0088 15.5695 12.0713 15.9133 12.1338V12.7588H16.9133V12.165C17.5383 12.04 18.0383 11.5713 18.132 10.915C18.257 10.165 17.8195 9.47754 17.0695 9.25879C17.0695 9.25879 16.4758 9.10254 16.3195 9.07129C15.9445 8.97754 15.757 8.72754 15.8195 8.50879C15.882 8.25879 16.382 7.97754 17.507 8.22754L17.7258 7.25879C17.4445 7.19629 17.1945 7.16504 16.9758 7.16504V6.57129H15.9758V7.25879C15.3195 7.44629 14.9758 7.85254 14.8508 8.29004C14.632 9.04004 15.132 9.79004 16.0695 10.04Z",
    fill: "#004431"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.d9d760dea66fb46b3477a1bdcc9eda7d.svg";
export { ForwardRef as ReactComponent };